import { useEffect, useState } from "react";
import axios from "axios";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ProductGrid } from "@/components/ProductGrid";
import { Reviews } from "@/components/Reviews";
import { SubscriptionTeaser } from "@/components/SubscriptionTeaser";
import { FeatureStrip } from "@/components/FeatureStrip";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data))
      .catch((e) => console.error("Producten laden mislukt", e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="home-page" className="bg-[#090D16] text-slate-100 min-h-screen">
      <div className="noise-overlay" />
      <Navbar />
      <Hero />
      <Marquee />
      {loading ? (
        <div className="py-32 text-center" data-testid="products-loading">
          <p className="font-display text-4xl text-slate-600 uppercase tracking-wide animate-pulse">
            Blasters laden...
          </p>
        </div>
      ) : (
        <ProductGrid products={products} />
      )}
      <Reviews />
      <SubscriptionTeaser />
      <FeatureStrip />
      <Footer />
      <CartDrawer />
    </div>
  );
}
